import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { AnalyticProvider } from '@application/analytic/analytic_context.provider';
import { withTranslation } from '@application/i18n/with_translation';
import { useTitle } from '@application/use_title';
import { TopBar } from '@component/top_bar.component';
import { useResolve, useResolveController, withNewContainer } from '@visiba/instantiation';
import { Route, Routes } from 'react-router';
import { AnonymousChat } from './screen_anonymous_chat/screen_anonymous_chat';
import { ScreenInitialMessage } from './screen_initial_message/screen_initial_message.component';
import { ScreenTemporaryUsername } from './screen_temporary_username/screen_temporary_username.component';
import { ViewAnonymousChatController } from './view_anonymous_chat.controller';

/**
 * Entrypoint for creating an anonymous chat.
 *
 * **NOTE:**
 * Will isolate dependency resolution within its subtree.
 */
export const ViewAnonymousChat = withNewContainer(function ViewAnonymousChat() {
	const controller = useResolveController(ViewAnonymousChatController);
	const analyticService = useResolve(AnalyticService);

	useTitle(withTranslation('View.CreateAnonymousChat.Title'));

	function handleAbort() {
		analyticService.trackEvent(AnalyticCategories.CreateAnonymousChat, 'Clicked', 'Abort button');
		controller.goToReceptionHome();
	}

	return (
		<AnalyticProvider category={AnalyticCategories.CreateAnonymousChat}>
			<TopBar.Content
				title={withTranslation('View.CreateAnonymousChat.Title')}
				onAbort={handleAbort}
				skipAbortDialog={true}
				goBack={true}
			/>
			<Routes>
				<Route path='/*' element={<ScreenTemporaryUsername />} />
				<Route path='/initial-message' element={<ScreenInitialMessage />} />
				<Route path='/chat/:caseId' element={<AnonymousChat />} />
			</Routes>
		</AnalyticProvider>
	);
});
